import createApp from './app.js'

import authService from './service.auth.js'
import messagingService from './service.messaging.js'

const appConfig = {"apiKey":"AIzaSyANoytFlt4I227hjTQrkBy6_4dTmVPJkaI","authDomain":"auth.paninti.com","projectId":"paninti-v2-4eda3","storageBucket":"paninti-v2-4eda3.firebasestorage.app","messagingSenderId":"118074774920","appId":"1:118074774920:web:d1a7861faf9f611ecb563d","measurementId":"G-BR11KE1T7H"}

export default async (ctx, inject) => {
  const { firebase, session } = await createApp(appConfig, ctx)

  let servicePromises = []

  if (process.server) {
    servicePromises = [
      authService(session, firebase, ctx, inject),

    ]
  }

  if (process.client) {
    servicePromises = [
      authService(session, firebase, ctx, inject),
      messagingService(session, firebase, ctx, inject),

    ]
  }

  const [
    auth,
    messaging
  ] = await Promise.all(servicePromises)

  const fire = {
    auth: auth,
    messaging: messaging
  }

    inject('fireModule', firebase)
    ctx.$fireModule = firebase

  inject('fire', fire)
  ctx.$fire = fire
}

function forceInject (ctx, inject, key, value) {
  inject(key, value)
  const injectKey = '$' + key
  ctx[injectKey] = value
  if (typeof window !== "undefined" && window.$nuxt) {
  // If clause makes sure it's only run when ready() is called in a component, not in a plugin.
    window.$nuxt.$options[injectKey] = value
  }
}